// Security: only allow safe URL schemes for dynamic hrefs / window.open.
// Returns the original URL string if it uses http/https/mailto/tel, else null.
export function safeUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  const ALLOWED = ['http:', 'https:', 'mailto:', 'tel:'];
  try {
    const parsed = new URL(trimmed, window.location.origin);
    return ALLOWED.includes(parsed.protocol) ? trimmed : null;
  } catch {
    return null;
  }
}

export default safeUrl;
